import React from 'react';

const PayNowModal = ({ paynowStatus, setPaynowStatus }) => {
  return (
    <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {paynowStatus.success ? 'Payment Instructions' : 'Payment Failed'}
            </h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={() => setPaynowStatus(null)}
            ></button>
          </div>
          <div className="modal-body">
            {paynowStatus.success ? (
              <>
                <div className="alert alert-success">
                  <h6>PayNow Payment Initiated Successfully!</h6>
                  <p className="mb-0">{paynowStatus.instructions}</p>
                </div>
                <div className="mt-3">
                  <p className="mb-1"><strong>Order ID:</strong> {paynowStatus.order_id}</p>
                  {paynowStatus.poll_url && (
                    <p className="text-muted small">
                      We'll notify you when payment is confirmed.
                    </p>
                  )}
                </div>
              </>
            ) : (
              <div className="alert alert-danger">
                <h6>Payment Failed</h6>
                <p>{paynowStatus.message || 'Unable to process PayNow payment. Please try another method.'}</p>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={() => setPaynowStatus(null)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayNowModal;